import gql from 'graphql-tag'
import { graphql } from 'react-apollo'

import { usersQuery } from 'bvdash/admin/users/queries/withUsers'
import { customerQuery } from 'bvdash/queries/settings/withCustomer'

import { projectQuery } from './withProject'
import { ProjectFragment } from './projectFragment'

const projectRemoveUsersMutation = gql`
  mutation projectRemoveUsers($projectId: ID!, $userIds: [ID]!) {
    projectRemoveUsers(projectId: $projectId, userIds: $userIds) {
      ok
      error
      project {
        ...ProjectFragment
      }
    }
  }
  ${ProjectFragment}
`

export const withProjectRemoveUsers = graphql(projectRemoveUsersMutation, {
  props: ({ mutate }) => ({
    projectRemoveUsers: (projectId, userIds) => {
      return mutate({
        variables: { projectId, userIds },
        awaitRefetchQueries: true,
        refetchQueries: [
          { query: usersQuery },
          { query: projectQuery, variables: { id: projectId } },
          { query: customerQuery },
        ],
      })
    },
  }),
})
